import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import {HomeComponent} from './home/home.component';
import {ModalRegistroComponent} from './modals/modal-registro/modal-registro.component';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {MatButtonModule} from '@angular/material/button';
import {
  MatInputModule,
  MatDialogModule,
  MatIconModule,
  MatDatepickerModule
} from '@angular/material';
import {ReactiveFormsModule} from '@angular/forms';
import {SliderComponent} from './slider/slider.component';
import {GeneralesModule} from '../../shared/generales/generales.module';

@NgModule({
  declarations: [
    HomeComponent,
    ModalRegistroComponent,
    SliderComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SlickCarouselModule,
    MatButtonModule,
    MatInputModule,
    MatDialogModule,
    MatIconModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    GeneralesModule
  ],
  entryComponents: [
    ModalRegistroComponent
  ]
})
export class HomeModule { }
